import { createAsyncThunk } from "@reduxjs/toolkit";

export const retrieveAllUsers = createAsyncThunk(
    '[USER] retrieveAllUsers',
    async (_, thunk) => {
        return await (thunk.extra as { userQuery: any }).userQuery.getAll();
    })